import { render, staticRenderFns } from "./VenueShortlist.vue?vue&type=template&id=44b193f4&"
import script from "./VenueShortlist.vue?vue&type=script&lang=js&"
export * from "./VenueShortlist.vue?vue&type=script&lang=js&"
import style0 from "./VenueShortlist.vue?vue&type=style&index=0&id=44b193f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports